import { render, staticRenderFns } from "./OrganizatAdmin.vue?vue&type=template&id=b0c47092&scoped=true"
import script from "./OrganizatAdmin.vue?vue&type=script&lang=js"
export * from "./OrganizatAdmin.vue?vue&type=script&lang=js"
import style0 from "./OrganizatAdmin.vue?vue&type=style&index=0&id=b0c47092&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0c47092",
  null
  
)

export default component.exports